import React from 'react'
import { AuthorLinkedinIcon } from '@/components/organisms/AuthorBio/AuthorLinkedinIcon'
type PublisherHeaderTooltipProps = {
  type: 'Author' | 'Reviewer'
  publisherData: {
    slug?: string
    fullName: string
    linkedin?: string
  }
}

const PublisherHeaderTooltip: React.FC<PublisherHeaderTooltipProps> = ({
  type,
  publisherData
}) => (
  <div className="flex w-full items-center gap-4 pb-2">
    {publisherData.slug && (
      <img
        src={`https://res.cloudinary.com/rehabpath/image/upload/v1655327781/${publisherData.slug}-circular-headshot.jpg`}
        className="size-12 rounded-md"
      />
    )}
    <div className="flex flex-col items-start gap-0.5">
      <span className="text-lg font-semibold text-gray-1100 md:text-sm">
        {publisherData.fullName}
      </span>
      <div className="flex flex-row gap-2 items-center h-5">
        <div className="text-sm text-gray-1100 font-normal">{type}</div>
        {publisherData.linkedin && (
          <>
            <span className="block h-3 w-px bg-gray-400" />
            <AuthorLinkedinIcon
              url={publisherData.linkedin}
              style="size-4 flex text-gray-700 py-2"
            />
          </>
        )}
      </div>
    </div>
  </div>
)

export default PublisherHeaderTooltip
